import { CommonModule, registerLocaleData } from '@angular/common'
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http'
import localeEn from '@angular/common/locales/en'
import localeEs from '@angular/common/locales/es'
import { ErrorHandler, NgModule } from '@angular/core'
import { AuthInterceptor, DynamoPaginationInterceptor, GeneralErrorHandler, LoadingInterceptor } from '@mmx/shared'
import { TranslateLoader, TranslateModule } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'

import { MaterialModule } from '../shared/modules/material.module'
import { AuthGuard, ClinicExistsGuard, PermissionsGuard } from './guards'

// const thirdPartyModules = [
//   CommonModule, // allows *ngIf and similar Angular utilities
//   FormsModule, // allows binding of [(ngModel)]
//   ReactiveFormsModule, // allows binding of [formGroup]
//   FlexLayoutModule, // allows fxLayout and fxFlex binding
// ]

registerLocaleData(localeEn, 'en')
registerLocaleData(localeEs, 'es')

/**
 * The CoreModule should contain singleton services and other
 * features where there’s only once instance per application.
 */
@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          return new TranslateHttpLoader(http, './assets/i18n/', '.json')
        },
        deps: [HttpClient],
      },
    }),
    MaterialModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DynamoPaginationInterceptor, multi: true },
    ClinicExistsGuard,
    AuthGuard,
    PermissionsGuard,
    { provide: ErrorHandler, useClass: GeneralErrorHandler },
  ],
})
export class CoreModule {}
